﻿import React, { useState, useEffect, useRef } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';
import { Row, Col } from 'reactstrap';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import usePrevious from '../CustomHooks/usePrevious';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import './Configuration.css';
import basePCUrl from '../../../Globals';
import GoogleTranslate from '../../GoogleTranslate/GoogleTranslate'


const Configuration = (props) => {

    useChangePageTitle("Configuration")
    const preferredLanguage = props.preferredLanguage
    const getTranslation = props.getTranslation

    //---------Display Settings----------//

    const [darkModeValue, setDarkModeValue] = useState()
    const [preferredLanguageValue, setPreferredLanguageValue] = useState()
    //--------Button Status--------//
    const [buttonStatus, setButtonStatus] = useState()
    //--------PlugIns Initial State Checked Value-------//
    const [outlookValue, setOutlookValue] = useState(false)
    const [chromeValue, setChromeValue] = useState(false)
    const [firefoxValue, setFirefoxValue] = useState(false)

    //--------PlugIns Initial State Locked-------//
    const [outlookLocked, setOutlookLocked] = useState(false)
    const [chromeLocked, setChromeLocked] = useState(false)
    const [firefoxLocked, setFirefoxLocked] = useState(false)

    const [applyButtonColor, setApplyButtonColor] = useState(false);
    const [finalApplyButtonColor, setFinalApplyButtonColor] = useState();

    const [autoScanWebsitesList, setAutoScanWebsitesList] = React.useState([
        { key: 0, label: 'Google' },
        { key: 1, label: 'Gmail' },
        { key: 2, label: 'Outlook OWA' },
        { key: 3, label: 'Reddit' },
        { key: 4, label: 'Facebook' },
        { key: 5, label: 'Facebook Messenger' },
        { key: 6, label: 'Yahoo Mail' },
        { key: 7, label: 'Yahoo Search' },
        { key: 8, label: 'Twitter' },
        { key: 9, label: 'Quora' },
        { key: 10, label: 'Slack Online' },
        { key: 11, label: 'Bing' },
        { key: 12, label: 'LinkedIn' },
    ]);

    const { getAccessTokenSilently, loading } = usePortalAuth();
    const [isLoading, setIsLoading] = useState();

    const theme = useTheme();

const returnFullLangauge =()=> {
    if (preferredLanguage !== undefined) {
    return preferredLanguage === "EN" ? getTranslation("English", preferredLanguage) :  
    //preferredLanguage === "EN-GB" ? "English" :
    preferredLanguage === "FR" ? getTranslation("French", preferredLanguage) :
    preferredLanguage === "JP" || preferredLanguage === "JA"  ? getTranslation("Japanese", preferredLanguage) :
    preferredLanguage === "TR" ? getTranslation("Turkish", preferredLanguage) :
    preferredLanguage === "ZH" ? getTranslation("Chinese", preferredLanguage) :
    preferredLanguage === "DL" ? getTranslation("Dutch", preferredLanguage) :
    preferredLanguage === "NB" ? getTranslation("Norwegian", preferredLanguage) :
    preferredLanguage === "DE" ? getTranslation("German", preferredLanguage) :
    preferredLanguage === "ES" ? getTranslation("Spanish", preferredLanguage) :
    preferredLanguage === "IT" ? getTranslation("Italian", preferredLanguage) :
    preferredLanguage === "PT" ? getTranslation("Portuguese", preferredLanguage) :
    //preferredLanguage === "PT-PT" ? "Portuguese" :
    getTranslation("No chosen language found", preferredLanguage)
    } else {
        return getTranslation("No chosen language found", preferredLanguage)
    }
} 

  //-------Settings Saved Message------//
  const ShowSuccessMessage = (msg) => {
    let x = document.getElementById('snackbar');
    x.innerHTML = msg;
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  };

  //--------Handle Submit--------//
  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();

    var data = {
      chrome: chromeValue,
      outlook: outlookValue,
      firefox: firefoxValue,
      darkmode: darkModeValue,
      userlanguage: props.preferredLanguage,
    };

    const headers = {
      Authorization: `Bearer ${token}`,
      Action: 'setUserSettings',
      'Content-Type': 'application/json',
    };

    fetch(basePCUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      //credentials: "same-origin",
      headers: headers,
    }).then((response) => {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }

      response.json().then((data) => {
        ShowSuccessMessage('Settings Saved');
        // if (data.status === "ok" && darkModeSwitch === configRefsDarkMode.current) {
        //     ShowMessage("Success")
        // } else if (data.status === "error" && darkModeSwitch === configRefsDarkMode.current) {
        //     ShowMessage("Something Went Wrong...");
        // }
        // console.log(data);
      });
    });

    if (darkModeValue === configRefsDarkMode.current) {
      setTimeout(() => {
        configRefsDarkMode.current = darkModeValue;
        configRefsOutlook.current = outlookValue;
        configRefsChrome.current = chromeValue;
        configRefsFirefox.current = firefoxValue;

        setIsLoading(false);
        setFinalApplyButtonColor('default');
        setButtonStatus(true);
      }, 5000);
    } else {
      props.toggleDarkMode(darkModeValue);
    }
  };


const userSettings = props.userSettings
console.log(userSettings)
console.log(darkModeValue)

    //--------Display Refs-------//
    const configRefsDarkMode = useRef();
    const configRefsPreferredLanguage = useRef();

    //--------Plugin Refs--------//
    const configRefsOutlook = useRef();
    const configRefsChrome = useRef();
    const configRefsFirefox = useRef();



    useEffect(() => {

      
                setDarkModeValue(userSettings.DarkMode)
                setPreferredLanguageValue(userSettings.UserLanguage)

                //--------PlugIns Checked Value-------//
                setOutlookValue(userSettings.Outlook.Value)
                setChromeValue(userSettings.Chrome.Value)
                setFirefoxValue(userSettings.Firefox.Value)

                //--------PlugIns Locked-------//
                setOutlookLocked(userSettings.Outlook.Locked)
                setChromeLocked(userSettings.Chrome.Locked)
                setFirefoxLocked(userSettings.Firefox.Locked)

                configRefsDarkMode.current = userSettings.DarkMode;
                configRefsPreferredLanguage.current = userSettings.UserLanguage;
                configRefsOutlook.current = userSettings.Outlook.Value;
                configRefsChrome.current = userSettings.Chrome.Value;
                configRefsFirefox.current = userSettings.Firefox.Value;
        
            }, [props.isLoading === false]);

    const checkSwitchChanges = () => {
        if (!props.isLoading) {
            if (darkModeValue != configRefsDarkMode.current ||
                outlookValue != configRefsOutlook.current ||
                chromeValue != configRefsChrome.current ||
                firefoxValue != configRefsFirefox.current
            ) {
                setFinalApplyButtonColor('primary')
                setButtonStatus(false)
            } else if (darkModeValue === configRefsDarkMode.current &&
                outlookValue === configRefsOutlook.current &&
                chromeValue === configRefsChrome.current &&
                firefoxValue === configRefsFirefox.current
            ) {
                setFinalApplyButtonColor('default')
                setButtonStatus(true)
            }

        }
    }


    useEffect(() => {

        checkSwitchChanges();

    }, [applyButtonColor]);




    const useStyles = makeStyles(theme => ({
        button: {
            margin: theme.spacing(1),
        },
        input: {
            display: 'none',
        },
        header: {
            fontFamily: 'Montserrat, sans-serif',
            //fontWeight: 300
        },
        chipRoot: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            listStyle: 'none',
            padding: theme.spacing(0.5),
            margin: 0,
        },
        chip: {
            margin: theme.spacing(0.5),
            color: 'white',
            backgroundColor: '#2ECC40'
        }
    }));

    const classes = useStyles();

    const renderSwitches = () => {
        return (

            <div>

                <div id="snackbar" />

                <Row>


                    <Col xs="auto">

                        <Paper id="plugin-switches-rectangle">
                            <h3>{getTranslation("Plug Ins", preferredLanguage)}</h3>
                            <div id="btns-top">

                                <FormControlLabel
                                    id="label"
                                    control={<Switch
                                        color="primary"
                                        disabled={outlookLocked}
                                        checked={outlookValue}
                                        onChange={() => { setOutlookValue(!outlookValue); setApplyButtonColor(!applyButtonColor) }}
                                        value="Outlook"
                                        name="Outlook.value"
                                        className="switch" />}
                                    label="Outlook"
                                    labelPlacement="end"

                                />

                                <br />
                                <FormControlLabel
                                    id="label"
                                    control={<Switch
                                        color="primary"
                                        disabled={chromeLocked}
                                        checked={chromeValue}
                                        onChange={() => { setChromeValue(!chromeValue); setApplyButtonColor(!applyButtonColor) }}
                                        value="Chrome"
                                        name="Chrome"
                                        className="switch" />}
                                    label="Chrome"
                                    labelPlacement="end"

                                />

                                <br />
                                <FormControlLabel
                                    id="label"
                                    control={<Switch
                                        color="primary"
                                        disabled={firefoxLocked}
                                        checked={firefoxValue}
                                        onChange={() => { setFirefoxValue(!firefoxValue); setApplyButtonColor(!applyButtonColor) }}
                                        value="Firefox"
                                        name="Firefox"
                                        className="switch" />}
                                    label="Firefox"
                                    labelPlacement="end"

                                />

                                <br />
                            </div>
                        </Paper>
                    </Col>




                    <Col xs="auto">
                        <Paper id="display-switches-rectangle" className="selector-darkMode-toggle">
                            <h3>{getTranslation("Display", preferredLanguage)}</h3>
                            <br />
                            <br />
                            <FormControlLabel
                                id="label"
                                control={<Switch color="primary" checked={darkModeValue} onChange={() => { setDarkModeValue(!darkModeValue); setApplyButtonColor(!applyButtonColor) }} />}
                                label={<Brightness4Icon style={{ color: theme.palette.action.active }} />}
                                labelPlacement="end"

                            />
                            <br />
                            {getTranslation("Your default langauge is currently", preferredLanguage)} {returnFullLangauge()}
                        </Paper>
                    </Col>

                    <Col xs="auto">

                        <Paper id="website-switches-rectangle" className="selector-website-list">

                            <h3>{getTranslation("Websites", preferredLanguage)}</h3>
                            <h5>{getTranslation("We automatically scan these websites while you view them.", preferredLanguage)}</h5>
                            <Grid container spacing={1}>
                                <br />
                                { autoScanWebsitesList === undefined ? null : autoScanWebsitesList.map((data) => {
                                    return (<Grid item xs={12} sm={6} md={6} lg={3}>
                                        <Chip
                                            key={data.key}
                                            label={data.label}
                                            className={classes.chip}
                                        />
                                    </Grid>
                                    );
                                })}
                            </Grid>

                        </Paper>
                    </Col>

                </Row>

                <span id="applySttingsButton"><Button disabled={buttonStatus} variant="contained" color={finalApplyButtonColor} onClick={() => handleSubmit()}>{getTranslation("Apply Settings", preferredLanguage)}</Button></span>
            </div>
        )

    }


    //-------Display Success/Error Message on Submit-------//
    const ShowMessage = (msg) => {
        var snackBar = document.getElementById("snackbar");
        snackBar.innerHTML = msg;
        snackBar.className = "show";
        setTimeout(function () { snackBar.className = snackBar.className.replace("show", ""); console.log("closing message");; }, 3900);
    }

    return (


        <div className="configWrap">

            <Typography className={classes.header} variant="h4" component="h3" gutterBottom>
                
                {getTranslation("Settings", preferredLanguage)}
                </Typography>

            <br />

            {!loading ? renderSwitches() : null}

            <div id="snackbar" />

        </div>
    );
}; export default Configuration


//setConfigurationData(result);
//setConfigurationData({
//    PlugInSettings: {
//        Chrome: {
//            value: chromeValue,
//            locked: chromeLocked
//        },
//        Outlook: {
//            value: outlookValue,
//            locked: outlookLocked
//        },
//        Firefox: {
//            value: firefoxValue,
//            locked: firefoxLocked
//        }
//    },
//    WebSiteSettings: {
//        Google: {
//            value: googleValue,
//            locked: googleLocked
//        },
//        Gmail: {
//            value: gmailValue,
//            locked: gmailLocked
//        },
//        OutlookOWA: {
//            value: outlookOWAValue,
//            locked: outlookOWALocked
//        },
//        Facebook: {
//            value: facebookValue,
//            locked: facebookLocked
//        },
//        Messenger: {
//            value: messengerValue,
//            locked: messengerLocked
//        },
//        YahooSearch: {
//            value: yahooSearchValue,
//            locked: yahooSearchLocked
//        },
//        YahooMail: {
//            value: yahooMailValue,
//            locked: yahooMailLocked
//        },
//        Twitter: {
//            value: twitterValue,
//            locked: twitterLocked
//        },
//        Quora: {
//            value: quoraValue,
//            locked: quoraLocked
//        },
//        SlackOnline: {
//            value: slackOnlineValue,
//            locked: slackOnlineLocked
//        },
//        Reddit: {
//            value: redditValue,
//            locked: redditLocked
//        },
//        LinkedIn: {
//            value: linkedInValue,
//            locked: linkedInLocked
//        },
//        Bing: {
//            value: bingValue,
//            locked: bingLocked
//        }
//    }
//})

//< div id = "plugin-switches-rectangle" >
//    <h3>Miscellaneous</h3>
//    <div id="btns-top">
//        <FormControlLabel
//            id="label"
//            control={<Switch
//                color="primary"
//                disabled={devServerModeLocked}
//                checked={devServerModeValue}
//                onChange={() => setDevServerModeValue(!devServerModeValue)}
//                value="Development Mode"
//                className="switch" />}
//            label="Development Mode"
//            labelPlacement="end"

//        />

//        <br />
//    </div>
//                    </div >

//  //--------WebSites Locked-------//
//  setGoogleLocked(data.webSiteSettings.google.locked)
//  setGmailLocked(data.webSiteSettings.gmail.locked)
//  setOutlookOWALocked(data.webSiteSettings.outlookOWA.locked)
//  setRedditLocked(data.webSiteSettings.reddit.locked)
//  setFacebookLocked(data.webSiteSettings.facebook.locked)
//  setMessengerLocked(data.webSiteSettings.messenger.locked)
//  setYahooMailLocked(data.webSiteSettings.yahooMail.locked)
//  setYahooSearchLocked(data.webSiteSettings.yahooSearch.locked)
//  setTwitterLocked(data.webSiteSettings.twitter.locked)
//  setQuoraLocked(data.webSiteSettings.quora.locked)
//  setSlackOnlineLocked(data.webSiteSettings.slackOnline.locked)
//  setBingLocked(data.webSiteSettings.bing.locked)
//  setLinkedInLocked(data.webSiteSettings.linkedIn.locked)

//--------devServerModeSettings----------

//setDevServerModeValue(data.devServerMode.value)
//setDevServerModeLocked(data.devServerMode.locked)

//userPlugInSettings: data.plugInSettings,
//userWebSiteSettings: data.webSitesEnabled,
//devServerMode: data.devServerMode,

//  PlugInSettings: {
//     Chrome: {
//         value: chromeValue,
//         locked: chromeLocked
//     },
//     Outlook: {
//         value: outlookValue,
//         locked: outlookLocked
//     },
//     Firefox: {
//         value: firefoxValue,
//         locked: firefoxLocked
//     }
// },
// WebSiteSettings: {
//     Google: {
//         value: googleValue,
//         locked: googleLocked
//     },
//     Gmail: {
//         value: gmailValue,
//         locked: gmailLocked
//     },
//     OutlookOWA: {
//         value: outlookOWAValue,
//         locked: outlookOWALocked
//     },
//     Facebook: {
//         value: facebookValue,
//         locked: facebookLocked
//     },
//     Messenger: {
//         value: messengerValue,
//         locked: messengerLocked
//     },
//     YahooSearch: {
//         value: yahooSearchValue,
//         locked: yahooSearchLocked
//     },
//     YahooMail: {
//         value: yahooMailValue,
//         locked: yahooMailLocked
//     },
//     Twitter: {
//         value: twitterValue,
//         locked: twitterLocked
//     },
//     Quora: {
//         value: quoraValue,
//         locked: quoraLocked
//     },
//     SlackOnline: {
//         value: slackOnlineValue,
//         locked: slackOnlineLocked
//     },
//     Reddit: {
//         value: redditValue,
//         locked: redditLocked
//     },
//     LinkedIn: {
//         value: linkedInValue,
//         locked: linkedInLocked
//     },
//     Bing: {
//         value: bingValue,
//         locked: bingLocked
//     }
// },
//DevServerMode: {
//    value: devServerModeValue,
//    locked: devServerModeLocked
//}

//--------WebSites Checked Value-------//
// setGoogleValue(result.webSiteSettings.google.value)
// setGmailValue(result.webSiteSettings.gmail.value)
// setOutlookOWAValue(result.webSiteSettings.outlookOWA.value)
// setRedditValue(result.webSiteSettings.reddit.value)
// setFacebookValue(result.webSiteSettings.facebook.value)
// setMessengerValue(result.webSiteSettings.messenger.value)
// setYahooMailValue(result.webSiteSettings.yahooMail.value)
// setYahooSearchValue(result.webSiteSettings.yahooSearch.value)
// setTwitterValue(result.webSiteSettings.twitter.value)
// setQuoraValue(result.webSiteSettings.quora.value)
// setSlackOnlineValue(result.webSiteSettings.slackOnline.value)
// setBingValue(result.webSiteSettings.bing.value)
// setLinkedInValue(result.webSiteSettings.linkedIn.value)

// configRefsGoogle.current = result.webSiteSettings.google.value;
// configRefsGmail.current = result.webSiteSettings.gmail.value;
// configRefsOutlookOWA.current = result.webSiteSettings.outlookOWA.value;
// configRefsReddit.current = result.webSiteSettings.reddit.value;
// configRefsFacebook.current = result.webSiteSettings.facebook.value;
// configRefsMessenger.current = result.webSiteSettings.messenger.value;
// configRefsYahooMail.current = result.webSiteSettings.yahooMail.value;
// configRefsYahooSearch.current = result.webSiteSettings.yahooSearch.value;
// configRefsTwitter.current = result.webSiteSettings.twitter.value;
// configRefsQuora.current = result.webSiteSettings.quora.value;
// configRefsSlackOnline.current = result.webSiteSettings.slackOnline.value;
// configRefsBing.current = result.webSiteSettings.bing.value;
// configRefsLinkedIn.current = result.webSiteSettings.linkedIn.value;

//--------Website Refs--------//
// const configRefsGoogle = React.useRef();
// const configRefsGmail = React.useRef();
// const configRefsOutlookOWA = React.useRef();
// const configRefsReddit = React.useRef();
// const configRefsFacebook = React.useRef();
// const configRefsMessenger = React.useRef();
// const configRefsYahooMail = React.useRef();
// const configRefsYahooSearch = React.useRef();
// const configRefsTwitter = React.useRef();
// const configRefsQuora = React.useRef();
// const configRefsSlackOnline = React.useRef();
// const configRefsBing = React.useRef();
// const configRefsLinkedIn = React.useRef();

// //--------WebSites Initial State Checked Value-------//
// const [googleValue, setGoogleValue] = useState()
// const [gmailValue, setGmailValue] = useState()
// const [outlookOWAValue, setOutlookOWAValue] = useState()
// const [redditValue, setRedditValue] = useState()
// const [facebookValue, setFacebookValue] = useState()
// const [messengerValue, setMessengerValue] = useState()
// const [yahooMailValue, setYahooMailValue] = useState()
// const [yahooSearchValue, setYahooSearchValue] = useState()
// const [twitterValue, setTwitterValue] = useState()
// const [quoraValue, setQuoraValue] = useState()
// const [slackOnlineValue, setSlackOnlineValue] = useState()
// const [bingValue, setBingValue] = useState()
// const [linkedInValue, setLinkedInValue] = useState()

// //--------WebSites Initial State Locked-------//
// const [googleLocked, setGoogleLocked] = useState(false)
// const [gmailLocked, setGmailLocked] = useState(false)
// const [outlookOWALocked, setOutlookOWALocked] = useState(false)
// const [redditLocked, setRedditLocked] = useState(false)
// const [facebookLocked, setFacebookLocked] = useState(false)
// const [messengerLocked, setMessengerLocked] = useState(false)
// const [yahooMailLocked, setYahooMailLocked] = useState(false)
// const [yahooSearchLocked, setYahooSearchLocked] = useState(false)
// const [twitterLocked, setTwitterLocked] = useState(false)
// const [quoraLocked, setQuoraLocked] = useState(false)
// const [slackOnlineLocked, setSlackOnlineLocked] = useState(false)
// const [bingLocked, setBingLocked] = useState(false)
// const [linkedInLocked, setLinkedInLocked] = useState(false)
